module.exports = __webpack_public_path__ + "img/currency.090d3804.png";